export default "__VITE_ASSET__BMmJsQvb__"